import React, { useState, useRef, useEffect } from "react";
import JisCheckbox from "./jisCheckbox"; // your existing checkbox
import DynamicIcon from "../dynamicicon";

export default function MultiSelectDropdown({ options, placeholder = "Select options", onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const dropdownRef = useRef();

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (option, checked) => {
    let updated;
    if (checked) {
      updated = [...selected, option];
    } else {
      updated = selected.filter((s) => s.id !== option.id);
    }
    setSelected(updated);
    onChange?.(updated.map((o) =>  ({id:o.id,title:o.title}))); // return only IDs if needed
  };

  const isSelected = (id) => selected.some((s) => s.id === id);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="multi-select-dropdown" style={{ position: "relative", width: "300px" }}>
      {/* Dropdown Header */}
      <div
        className="dropdown-header"
        onClick={toggleDropdown}
        style={{
          border: "1px solid #ccc",
          borderRadius: "6px",
          padding: "8px 12px",
      
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <span>
          {selected.length > 0
            ? selected.map((s) => s.title).join(", ")
            : <span style={{ color: "#aaa" }}>{placeholder}</span>}
        </span>
        <span style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0)", transition: "0.2s" }}><DynamicIcon iname={"chevron-down"}/></span>
      </div>

      {/* Dropdown List */}
      {isOpen && (
        <div
          className="dropdown-list"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: "6px",
            marginTop: "4px",
            maxHeight: "250px",
            overflowY: "auto",
            zIndex: 1000,
            padding: "6px 8px"
          }}
        >
          {options.map((opt) => (
            <JisCheckbox
              key={opt.id}
              label={opt.title}
              value={isSelected(opt.id)}
              onChange={(checked) => handleSelect(opt, checked)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
